import type {
  GetActiveAccountingSystemRequest,
  GetActiveAccountingSystemResult,
} from "@src/domain/dto/accountingOAuth";
import type { IAccountingOAuthRepository } from "@src/domain/repositories/accountingOAuth";

export class GetActiveAccountingSystemUseCase {
  private readonly repository: IAccountingOAuthRepository;

  constructor(repository: IAccountingOAuthRepository) {
    this.repository = repository;
  }

  execute(
    params: GetActiveAccountingSystemRequest,
  ): Promise<GetActiveAccountingSystemResult> {
    return this.repository.getActiveSystem(params);
  }
}
